module.exports = __webpack_public_path__ + "img/1.446a946e.jpeg";